import { Action, handleActions } from 'redux-actions';
import { combineReducers } from 'redux';
import { debug } from '../../../utils';
import actions from './actions';
import { fetch, post, clear } from './actions';

// interface Profile {
//     username: string;
//     email: string;
//     email_verified: boolean;
//     research_participant: boolean;
// }

interface ProfileReducers { [actionType: string]: {(state: any, action: Action<any>): any };}

const _ProfileReducers: ProfileReducers = {
    [fetch.names.START]:  (state, action) => ({ inProgress: true, data: {} }),
    [fetch.names.COMPLETED]:  (state, {payload}) => ({ inProgress: false, data: payload }),
	[fetch.names.REJECTED]:  (state, {payload}) => (null),
    [actions.clear]:  (state, {payload}) => (null)
};

const initialState = null;
const ProfileReducers = handleActions<any>(_ProfileReducers, initialState as any);

export default { profile: ProfileReducers };



// WEBPACK FOOTER //
// ./src/app/models/Profile/reducers.ts